import { call, put, select, takeEvery } from 'redux-saga/effects';
import { types } from '@actions/blockedAttendees';
import { getBlockedAttendees, unblockAttendee } from '@services/blockedAttendeesResource';
import { tokenSelector } from '@selectors/authentication';

export function* getBlockedAttendeesSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const response = yield call(getBlockedAttendees, token);
    const blockedAttendees = response.data.map(({ email, id, roles }) =>
      roles.length > 0
        ? { email, id, role: roles[0].name }
        : { email, id, role: 'Undefined' },
    );
    yield put({
      type: types.GET_BLOCKED_ATTENDEES.SUCCESS,
      blockedAttendees,
    });
  } catch (err) {
    yield put({
      type: types.GET_BLOCKED_ATTENDEES.FAILURE,
      message: err.message || 'Failed to fetch blocked attendees.',
    });
  }
}

export function* unblockAttendeeSaga(action) {
  try {
    const token = yield select(tokenSelector);
    yield call(unblockAttendee, action.id, token);
    yield put({
      type: types.UNBLOCK_ATTENDEE.SUCCESS,
    });
    const response = yield call(getBlockedAttendees, token);
    const blockedAttendees = response.data.map(({ email, id, roles }) =>
      roles.length > 0
        ? { email, id, role: roles[0].name }
        : { email, id, role: 'Undefined' },
    );
    yield put({
      type: types.GET_BLOCKED_ATTENDEES.SUCCESS,
      blockedAttendees,
    });
  } catch (err) {
    yield put({
      type: types.UNBLOCK_ATTENDEE.FAILURE,
      message: err.message || 'Failed to unblock attendee.',
    });
  }
}

export default function* adminWatcherSaga() {
  yield takeEvery(types.GET_BLOCKED_ATTENDEES.STARTED, getBlockedAttendeesSaga);
  yield takeEvery(types.UNBLOCK_ATTENDEE.STARTED, unblockAttendeeSaga);
}



// WEBPACK FOOTER //
// ./redux/sagas/blockedAttendees.js